export const autofocus = {
    mounted(el) {
        el.focus()
    }
}
